module.exports = __webpack_public_path__ + "img/zhsw.1766306608134.png";